import { Record, Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, union_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Datenschutz", "Impressum"];
    }
}

export function Page_$reflection() {
    return union_type("StaticPages.Types.Page", [], Page, () => [[], []]);
}

export class Msg extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Load"];
    }
}

export function Msg_$reflection() {
    return union_type("StaticPages.Types.Msg", [], Msg, () => [[["Item", Page_$reflection()]]]);
}

export class Model extends Record {
    constructor(Page) {
        super();
        this.Page = Page;
    }
}

export function Model_$reflection() {
    return record_type("StaticPages.Types.Model", [], Model, () => [["Page", Page_$reflection()]]);
}

export function Model__get_Headline(model) {
    if (model.Page.tag === 1) {
        return "Impressum";
    }
    else {
        return "Datenschutz";
    }
}

//# sourceMappingURL=Types.fs.js.map
